<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <b-row>
      <b-col>
        <b-text-input-validated
          v-model="date"
          type="date"
          rules="required"
          label="Session Date"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col
        ><b-text-input-validated
          v-model="startTime"
          type="time"
          rules="required"
          label="Session Start"
      /></b-col>
      <b-col
        ><b-text-input-validated
          v-model="endTime"
          type="time"
          rules="required"
          label="Session End"
      /></b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-text-input-validated
          v-model="report"
          text-area
          rules="required"
          label="Report"
          placeholder="Describe what was covered in the session. This is public and will be seen by your student"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-text-input-validated
          v-model="assignment"
          text-area
          rules="required"
          label="Assignment"
          placeholder="What does your student need to do before your next session?"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-text-input-validated
          v-model="notes"
          text-area
          label="Notes"
          placeholder="Any other notes you have on the session or the student that might be useful, particularly if another tutor has to cover a session for you. This is private and will not be seen by the student"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p v-if="actionError" class="tsny_status-text">
          {{ actionErrorText }}
        </p>
      </b-col>
    </b-row>
  </ValidationObserver>
</template>

<script>
import EventBus from "../../services/eventBus/EventBus";
import EventConstants from "../../services/eventBus/EventConstants";
import { ValidationObserver } from "vee-validate";
import BTextInputValidated from "../FormInputs/BTextInputValidated";

export default {
  name: "SessionReportForm",
  components: { ValidationObserver, BTextInputValidated },
  props: {
    sessionReport: {
      type: Object,
      default: null
    },
    actionError: {
      type: Boolean,
      default: null
    },
    actionErrorText: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      date: null,
      startTime: null,
      endTime: null,
      report: null,
      assignment: null,
      notes: null
    };
  },
  watch: {
    async hasErrors() {
      this.$emit("update-errors", await this.$refs.observer.validate());
    }
  },
  mounted: function() {
    EventBus.$on(
      EventConstants.EVENTS.SESSION_REPORT_FORM_SUBMISSION,
      this.handleFormSubmission
    );

    if (this.sessionReport) {
      this.date = this.sessionReport.date;
      this.startTime = this.sessionReport.startTime;
      this.endTime = this.sessionReport.endTime;
      this.report = this.sessionReport.report;
      this.assignment = this.sessionReport.assignment;
      this.notes = this.sessionReport.notes;
    }
  },
  destroyed() {
    EventBus.$off(EventConstants.EVENTS.SESSION_REPORT_FORM_SUBMISSION);
  },
  methods: {
    handleFormSubmission() {
      let data = {
        validationObserver: this.$refs.observer,
        sessionReport: {
          _id: this.sessionReport._id,
          date: this.date,
          startTime: this.startTime,
          endTime: this.endTime,
          report: this.report,
          assignment: this.assignment,
          notes: this.notes
        }
      };

      this.$emit("form-data", data);
    }
  }
};
</script>

<style scoped></style>
